export * from "./tabs-quote";
export { TabsQuote as default } from "./tabs-quote";
